"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectStatus = require("./ProjectStatus");
var SecuritySettings = require("./Security/Security");
var Promote_1 = __importDefault(require("./Promote/Promote"));
var ShareUI_1 = __importDefault(require("./ShareUI"));
var SharingSettings_1 = __importDefault(require("./SharingSettings/SharingSettings"));
var LinkPreviewSettingsMount_1 = require("./LinkPreviewSettings/LinkPreviewSettingsMount");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var LinkPreviewSettingsStore_1 = require("./LinkPreviewSettings/LinkPreviewSettingsStore");
var SocialShareService_1 = require("@CommonFrontend/SocialShare/SocialShareService");
var disabledAcceptAndQuoteLinkTooltip = null;
var disabledAcceptAndQuotePromoteTooltip = null;
var ShareController = (function () {
    function ShareController(invoke, make, usingFeature, upseller, apiBaseUrl, persist, project, close, externalClass, projectStatusChecker, projectSecurer, projectLinkRetriever, makeDraftLiveToggle, Link, permissionsService, makeUpsellTooltip, projectService, projectTelemetry, hint, speechBubble, account) {
        var _this = this;
        this.project = project;
        this.close = close;
        this.externalClass = externalClass;
        var isDisabled = function () { return !projectStatusChecker.isPublicViewable(_this.project); };
        var onDisabledClick = function () {
            if (isDisabled()) {
                return speechBubble.explain({
                    targetSelector: ".share-project .draft-live-toggle .toggle-button__mount",
                    message: "Before sharing your link, set your page live to collect analytics",
                    position: "top",
                });
            }
        };
        var projectStatus = make(ProjectStatus, {
            project: this.project,
        });
        this.getProjectStatusProps = function () {
            var statusObject = projectStatus.getProperties();
            if (!statusObject.iconText && !statusObject.iconClass) {
                statusObject.iconText = "●";
            }
            return statusObject;
        };
        var draftHint = null;
        var liveHint = null;
        var projectStatusHint = null;
        var createDraftHint = function () {
            return hint.large({
                targetSelector: ".share-project .draft-live-toggle .toggle-button__mount",
                hint: "Set your page live when you're ready to share and collect analytics",
            });
        };
        var createLiveHint = function () {
            return hint.large({
                targetSelector: ".share-project .draft-live-toggle .toggle-button__mount",
                hint: "Switch to draft if you need to prevent viewers from accessing your page content",
            });
        };
        var createPendingStatusHint = function () {
            return hint.large({
                targetSelector: ".share-project .status-message .live",
                hint: "Once your quote is accepted, your page will change from pending to accepted",
            });
        };
        var draftLiveToggle = invoke(makeDraftLiveToggle, null, {
            options: {
                tooltipOffset: 5,
                toggleHandle: function (newStatus) {
                    if (newStatus === "live") {
                        if (draftHint) {
                            draftHint.remove();
                        }
                        liveHint = createLiveHint();
                        if (projectStatus.getProperties().text === "Pending") {
                            return (projectStatusHint = createPendingStatusHint());
                        }
                    }
                    else {
                        if (liveHint) {
                            liveHint.remove();
                        }
                        if (projectStatusHint) {
                            projectStatusHint.remove();
                        }
                        return (draftHint = createDraftHint());
                    }
                },
            },
        });
        this.draftLiveToggleUi = draftLiveToggle.ui;
        if (draftLiveToggle.canToggleStatus()) {
            if (isDisabled()) {
                draftHint = createDraftHint();
            }
            else {
                liveHint = createLiveHint();
            }
        }
        if (projectStatus.getProperties().text === "Pending") {
            projectStatusHint = createPendingStatusHint();
        }
        if (disabledAcceptAndQuoteLinkTooltip) {
            disabledAcceptAndQuoteLinkTooltip.remove();
        }
        if (disabledAcceptAndQuotePromoteTooltip) {
            disabledAcceptAndQuotePromoteTooltip.remove();
        }
        if (projectService.shouldDisableAcceptAndQuoteAccess(this.project)) {
            disabledAcceptAndQuoteLinkTooltip = makeUpsellTooltip({
                message: "to share Qwilr Pages with a Quote or Accept block.",
                targetSelector: ".share-project .share-project-link",
                upgradePosition: "start",
                options: {
                    showOnHover: true,
                },
            });
            disabledAcceptAndQuotePromoteTooltip = makeUpsellTooltip({
                message: "to promote Qwilr Pages with a Quote or Accept block.",
                targetSelector: ".share-project .promote",
                upgradePosition: "start",
                options: {
                    showOnHover: true,
                },
            });
        }
        var isAccepted = this.project.status === "accepted";
        var canEdit = permissionsService.isAllowed(this.project.$userAction, "edit") ||
            permissionsService.isAllowed(this.project.userAction, "edit");
        this.canEditProjectName = !isAccepted && canEdit;
        this.canEditSettings = canEdit;
        var linkPreviewSettingsStore = new LinkPreviewSettingsStore_1.LinkPreviewSettingsStore(project, account);
        this.onProjectNameChange = function () {
            return projectTelemetry.projectEdited(_this.project);
        };
        var getLinkUrl = function () {
            var links = projectLinkRetriever.getAllUrlsForProject(_this.project);
            return links.customDomain || links.subdomain || links.primaryDomain;
        };
        var getProjectName = function () {
            return _this.project.name;
        };
        this.getLink = function () {
            return make(Link, {
                linkUrl: getLinkUrl,
                options: {
                    isDisabled: function () { return isDisabled() || projectService.shouldDisableAcceptAndQuoteAccess(_this.project); },
                    onDisabledClick: onDisabledClick,
                    isNewVersion: true,
                },
            });
        };
        this.linkPreviewSettingsUi = invoke(LinkPreviewSettingsMount_1.mountLinkPreviewSettings, null, {
            canEdit: canEdit,
            linkPreviewSettingsStore: linkPreviewSettingsStore,
            projectId: this.project._id,
            usingFeature: usingFeature,
        });
        var linkPreviewOptionsSection = make(require("./Section/Section"), {
            icon: "image-16.svg",
            info: "Change image preview for this link",
            isComplete: false,
            streamlined: true,
        });
        this.linkPreviewOptionsSectionUi = linkPreviewOptionsSection.ui;
        var sharingSettings = make(SharingSettings_1.default);
        this.sharingSettingsUi = sharingSettings.ui;
        var sharingOptionsSection = make(require("./Section/Section"), {
            icon: "settings-16.svg",
            info: "Edit sharing settings for this link",
            isComplete: sharingSettings.hasSharingSettingsEnabled,
            streamlined: false,
        });
        this.sharingOptionsSectionUi = sharingOptionsSection.ui;
        this.isSharingDisabled = function () { return isDisabled() || projectService.shouldDisableAcceptAndQuoteAccess(_this.project); };
        var securitySettings = make(SecuritySettings, { link: this.project.links[0] });
        this.securitySettingsUi = securitySettings.ui;
        var securityOptionsSection = make(require("./Section/Section"), {
            icon: "lock-16.svg",
            info: "Edit security settings for this link",
            isComplete: securitySettings.hasSecurityEnabled,
            streamlined: false,
        });
        this.securityOptionsSectionUi = securityOptionsSection.ui;
        this.canAccessSecuritySettings = function () {
            return (usingFeature(FeatureFlag_1.FeatureFlag.Security) ||
                projectSecurer.getEnabledSecurityMeasures(_this.project.links[0]).length > 0);
        };
        this.showSecurityInaccessible = function () {
            return upseller.upsell({
                feature: "security",
                customUpsellMessage: "Protect your Qwilr pages with passwords, time limits & view limits.",
                customUpsellHelpLink: "https://help.qwilr.com/category/316-securing",
            });
        };
        this.promoteUi = invoke(Promote_1.default, null, {
            getSocialLinks: function () {
                return (0, SocialShareService_1.getSocialLinks)(getProjectName(), getLinkUrl(), SocialShareService_1.SocialShareUtmMedium.InAppShare);
            },
            isDisabled: function () { return isDisabled() || projectService.shouldDisableAcceptAndQuoteAccess(_this.project); },
            onDisabledClick: onDisabledClick,
            link: this.getLink().ui,
        });
        this.initialisePersist = function (scope) {
            scope.project = _this.project;
            if (_this.canEditProjectName) {
                return make(persist, {
                    options: {
                        watchObject: "project.name",
                        scope: scope,
                        payloadName: "name",
                        apiRoute: "".concat(apiBaseUrl, "/projects/").concat(_this.project._id),
                    },
                });
            }
        };
        this.ui = invoke(ShareUI_1.default, null, {
            controller: this,
            linkPreviewSettingsStore: linkPreviewSettingsStore,
        });
    }
    return ShareController;
}());
exports.default = ShareController;
